"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAudienceRequestBaseToJSON = exports.CreateAudienceRequestBaseFromJSONTyped = exports.CreateAudienceRequestBaseFromJSON = exports.instanceOfCreateAudienceRequestBase = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateAudienceRequestBase interface.
 */
function instanceOfCreateAudienceRequestBase(value) {
    var isInstance = true;
    isInstance = isInstance && "audienceType" in value;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateAudienceRequestBase = instanceOfCreateAudienceRequestBase;
function CreateAudienceRequestBaseFromJSON(json) {
    return CreateAudienceRequestBaseFromJSONTyped(json, false);
}
exports.CreateAudienceRequestBaseFromJSON = CreateAudienceRequestBaseFromJSON;
function CreateAudienceRequestBaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceType': json['audience_type'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
    };
}
exports.CreateAudienceRequestBaseFromJSONTyped = CreateAudienceRequestBaseFromJSONTyped;
function CreateAudienceRequestBaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audience_type': value.audienceType,
        'name': value.name,
        'description': value.description,
    };
}
exports.CreateAudienceRequestBaseToJSON = CreateAudienceRequestBaseToJSON;
